import { useMemo } from 'react';
import { useContextParams } from '@core/params/context';
import { useGetPlayerNestedTrackingPayload } from '@embed/components/VideoPlayer/Player3/hooks/useGetPlayerNestedTrackingPayload';
import { trackingFactory } from '@player/tracking';
/**
 * Reusable hook providing Player related tracking calls.
 */
export function usePlayerTracking() {
    const params = useContextParams();
    const getPlayerNestedTrackingPayload = useGetPlayerNestedTrackingPayload();
    return useMemo(() => trackingFactory({
        params,
        getPlayerNestedTrackingPayload,
    }), [params, getPlayerNestedTrackingPayload]);
}
